import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 12px;
`;

export const TitleContainer = styled.div`
  max-width: 412px;
  display: flex;
  margin-right: 12px;

  h1 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 28px;
  }
`;

export const Wrapper = styled.div<{ hasButton: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: ${({ hasButton }) => (hasButton ? "4px 0" : "8px 0")};
`;

export const LeftColumn = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const RightColumn = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
`;
